import { useState } from "react";

interface UseSearchOptions {
	initialSearch?: string;
	onSearchChange?: (search: string) => void;
}

function useSearch(options: UseSearchOptions = {}) {
	const { initialSearch = "", onSearchChange } = options;

	const [search, setSearch] = useState(initialSearch);

	function handleSearchChange(value: string) {
		setSearch(value);
		onSearchChange?.(value);
	}

	function clearSearch() {
		setSearch("");
		onSearchChange?.("");
	}

	return {
		// State
		search,

		// Handlers
		handleSearchChange,
		clearSearch,
	};
}

export { useSearch };
